import { render } from "./Associations.vue?vue&type=template&id=1089308a"
import script from "./Associations.vue?vue&type=script&lang=js"
export * from "./Associations.vue?vue&type=script&lang=js"

import "./Associations.vue?vue&type=style&index=0&id=1089308a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__